import request from 'utils/request'
import selector from 'modules/Auth/selectors.js'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import corporateRequest from 'utils/corporateRequest'



export const getUserMetrics = () => async (dispatch, getState) => {
  try {
    const state = getState()
    const instituteCampusId = selector.getInstituteDetails(state)?.id
    const response = await request.get(
      `/users/metrics?instituteCampusId=${instituteCampusId}`
    )
    dispatch(setUserMetrics(response?.data?.data || {}))
    return response
  } catch (error) {
    return error
  }
}

export const getUserList =
  ({ searchValue, sortBy, userRoleValue, userStatus, pageNum }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const instituteId = selector.getInstituteCampusId(state)

      const search = searchValue ? `&search=${searchValue}` : ''

      const sortKey = sortBy?.columnKey ? `&sortBy=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''

      const userRole = userRoleValue?.length > 0 ? `&Role=${userRoleValue}` : ''
      const status = userStatus?.length > 0 ? `&status=${userStatus}` : ''

      const response = await request.get(
        `/user?pageLimit=10&currentPage=${pageNum}&instituteId=${instituteId}${sortKey}${sortOrder}${search}${userRole}${status}`
      )
      dispatch(setUserList(response?.data?.data))
      return false
    } catch (error) {
      return false
    }
  }

export const createCorporate =
  (payload) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const instituteId = selector.getInstituteDetails(state)?.instituteId
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      let updatedPayload = {
        ...payload,
        instituteCampusId: instituteCampusId,
      }

      const response = await corporateRequest.post(`/corporate/institute/createcompany`, updatedPayload)
      return response
    } catch (error) {
      //console.log(error)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

  export const getSectorMaster = (search) =>
  async (dispatch, getState) => {
    let searchData = search ? `&search=${search}`: ''
    let isActive = 'true';
    try {
      const response = await corporateRequest.get(`/corporate/crud/sector?pageLimit=50${searchData}&isActive=${isActive}`)
      return response?.data?.data
    } catch (error) {
      return error
    }
  }
export const getCorporateList = (searchValue,pageNum,sortBy,applyFilter) =>
  async (dispatch, getState) => {
    const search = searchValue ? `&search=${searchValue.trim()}` : ''

    const sortKey = sortBy?.columnKey ? `&sort=${sortBy?.columnKey}` : ''
    const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
    const sortOrder = sortBy?.order ? `&order=${order}` : ''
    const sector = applyFilter?.length > 0 ? `&sectorId=${applyFilter?.join()}` : ''

    try {
      const state = getState()
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      const response = await corporateRequest.get(`/corporate/institute/${instituteCampusId}/company?pageLimit=10&pageNo=${pageNum}${search}${sortKey}${sortOrder}${sector}`)

      return response?.data?.data
    } catch (error) {
      return error
    }
  }

  export const getCorporateFilter = () =>
    async (dispatch, getState) => {
    
  
      try {
        const state = getState()
        const instituteCampusId = selector.getInstituteDetails(state)?.id
        const response = await corporateRequest.get(`/corporate/institute/${instituteCampusId}/filtercompany`)
  
        return response?.data?.data
      } catch (error) {
        return error
      }
    }

  export const getSingleCoporate = (corporateId) =>
    async (dispatch, getState) => {
      try {

        const state = getState()
        const instituteCampusId = selector.getInstituteDetails(state)?.id
        const response = await corporateRequest.get(`/corporate/institute/${instituteCampusId}/company/${corporateId}`)
        return response?.data?.data
      } catch (error) {
        return error
      }
    }
    export const updateCorporate =
    (payload,corporateId) =>
    async (dispatch, getState) => {
      try {
        const state = getState()
        const instituteCampusId = selector.getInstituteDetails(state)?.id
        let updatedPayload = {
          ...payload,
          instituteCampusId: instituteCampusId,
        }
  
        const response = await corporateRequest.put(`/corporate/institute/updatecompany/${corporateId}`, updatedPayload)
        return response
      } catch (error) {
        //console.log(error)
        ErrorMessage(error?.response?.data?.message)
        return error
      }
    }

export const updateUserStatus =
  ({ userId, status }) =>
  async (dispatch, getState) => {
    try {
      const response = await request.patch(`/user/${userId}/status`, {
        status: status,
      })
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage(
          status
            ? 'User activated successfully!'
            : 'User inactivated successfully!'
        )
      }

      return response
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const deleteCoprorateDetails =
  (companyId) =>
  async (dispatch, getState) => {
    try {
      const response = await corporateRequest.delete(`/corporate/institute/deletecompany/${companyId}`)
      // if (response?.status >= 200 && response?.status <= 300) {
      //   SuccessMessage('User Deleted Successfully!')
      // }
      return response
    } catch (error) {
      // ErrorMessage(error?.response?.data?.message)
      return error
    }
  }


  export const bulkUploadCorporate =
  (payload) => async (dispatch, getState) => {
    let result ;
    try {
      const state = getState()
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      let updatedPayload = {
        ...payload,
        instituteCampusId: instituteCampusId,
      }
       result = await corporateRequest.post(
        `/corporate/institute/companybulkupload`,
        updatedPayload
      )
      return result
    } catch (error) {
      
      return error
    }
  }


